module.exports = __webpack_public_path__ + "0f964a72f8fbdf9c8d4e0122b8effb40.woff";